import axios from "axios";

import { successHandling } from "../helpers/successHandling";
import { apiSelectedDeviceIdsHandler } from "../helpers/apiSelectedIdsHandler";
import { handleHasResponseStatus } from "../helpers/commandConfirmationDialogAction";

export const updateDevicesVncSecurityAPI = async (
  t,
  filterDevicesBy,
  deviceIds,
  IsTwoFactorEnable,
  pwd,
  setOpen,
  resetAllStoredValueInLocalforage
) => {
  let formData = new FormData();
  formData.append("password", pwd);
  formData.append("is_two_factor_enable", IsTwoFactorEnable);
  apiSelectedDeviceIdsHandler(formData, filterDevicesBy, deviceIds);

  try {
    await axios({
      url: `/api/v2/vnc/security/update-devices`,
      method: "POST",
      data: formData
    });

    const successfulText = `${t("task.successfullyUpdateVNCSecuritySetting")}`;
    successHandling(t, successfulText);
    handleHasResponseStatus(setOpen, resetAllStoredValueInLocalforage);
    return true;
  } catch (error) {
    setOpen(false);
  }
};
